import { UntrustedDataMembers } from '@auth0/auth0-acul-js';

import { EXTRA_AUTH_PARAMS_KEY_MAP } from '@page/core/services/auth/auth.service';

export const isNewAuthUser = (untrustedData: UntrustedDataMembers) => {
  return untrustedData.authorizationParams?.[EXTRA_AUTH_PARAMS_KEY_MAP.IS_NEW_USER] === 'true';
};

export const isCreateOrganization = (untrustedData: UntrustedDataMembers) => {
  return untrustedData.authorizationParams?.[EXTRA_AUTH_PARAMS_KEY_MAP.IS_CREATE_ORG] === 'true';
};

export const isUserInvited = (untrustedData: UntrustedDataMembers) => {
  return untrustedData.authorizationParams?.[EXTRA_AUTH_PARAMS_KEY_MAP.IS_USER_INVITED] === 'true';
};
